import { Box, Typography } from '@mui/joy';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import { API_URL } from '../../api';

export const formatMessageDate = value => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};
const fileUrl = url => {
  if (!url) return null;
  try {
    const parsed = new URL(url, API_URL);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : null;
  } catch (_) { return null; }
};

export default function ChatBubble({ message, isYou, showName = false }) {
  if (message?.type_sender === 'system') return <Box className="lv-thread-system">{message.content}</Box>;
  return (
    <Box className={`lv-thread-bubble${isYou ? ' is-mine' : ''}`}>
      {showName && !isYou && (message.sender_name || message.sender?.full_name) && <Typography level="body-xs" className="lv-thread-sender">{message.sender_name || message.sender.full_name}</Typography>}
      {message?.content && <Box className="lv-thread-text">{message.content}</Box>}
      {(message.attachments || []).map(attachment => {
        const href = fileUrl(attachment.url);
        if (!href) return null;
        return <a key={attachment.id ?? href} href={href} target="_blank" rel="noopener noreferrer" className="lv-thread-attachment-link">
          {attachment.type === 'photo'
            ? <img src={href} alt={attachment.name || 'Фотография'} loading="lazy" />
            : <><InsertDriveFileRoundedIcon sx={{ color: 'inherit', fontSize: 22 }} /><span>{attachment.name || 'Открыть файл'}</span></>}
        </a>;
      })}
      <Box className="lv-thread-time"><time dateTime={message.date_create}>{formatMessageDate(message.date_create)}</time></Box>
    </Box>
  );
}
